export const SEVERITY_COLOR: Record<string, string> = {
  error:   '#d32f2f',
  warning: '#ed6c02',
  success: '#2e7d32',
  info:    '#0288d1',
};

export const SEVERITY_BG: Record<string, string> = {
  error:   '#ffebee',
  warning: '#fff3e0',
  success: '#e8f5e9',
  info:    '#e3f2fd',
};

// Notification "type" (business action, e.g. COUNT/SAVE/EXPORT) is distinct from `severity`
// (error/warning/success/info): severity says how alarming a notification is, type says what
// action produced it. Non-alerting notifications (severity "info") are colored by type instead,
// so the list reads as "what happened" rather than everything looking like the same generic blue.
// Kept deliberately muted/desaturated — these tint a small icon badge, not the whole card.
export const TYPE_COLOR: Record<string, string> = {
  COUNT:  '#1976d2',
  SAVE:   '#8e44ad',
  EXPORT: '#43a047',
};

export const DEFAULT_TYPE_COLOR = '#757575';
